import * as React from 'react';
import { forwardRef, useEffect, useState } from 'react';
import ClickToEdit from 'react-click-to-edit';

const roleMapping = {
  delegate: 'DELEGATE',
  exhibitor: 'EXHIBITOR',
  speaker: 'SPEAKER',
  superadmin: 'ORGANISER',
  'vip/faculty': 'VIP / FACULTY',
};

export const PrintContent = React.forwardRef<HTMLDivElement, any>(
  (props, ref) => {
    const { user, setEditMode } = props;
    const { fullName, role, qrLabel } = user;

    const renderField = (value, className = '') => (
      <ClickToEdit
        wrapperClass={`line ${className}`}
        initialValue={value}
        startEditing={() => {
          setEditMode(true);
        }}
        endEditing={() => {
          setEditMode(false);
        }}
      />
    );

    return (
      <div ref={ref} className="print-container">
        <div className="print-text">
          {/* <div className="imageGap"></div> */}
          {renderField(fullName, 'fullName')}
          {renderField(user.institution, 'organisation')}
          {renderField(roleMapping[role], 'role')}
          {/* <img id="qrLabel" src={qrLabel} /> */}
        </div>
      </div>
    );
  }
);

// const PrintContent = forwardRef(PrintContentRef)
export default PrintContent;
